import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetStores_storeId_ = "/stores/:storeId";

export type ParamsGetStores_storeId_ = ExtractRouteParams<typeof RouteGetStores_storeId_>;

export type ResponseGetStores_storeId_ = {
  id: number;
  code: string;
};
